import _ from 'lodash';
import ah from '../utils/ajax-helper'; // time format: YYYY-MM-dd HH:MM:ss
// keyword 搜尋欄位為車牌號碼、貨櫃號碼、貨運業者名稱與駕駛身分證字號
// 取得貨櫃中心進出統計

export var getStatsZones = function getStatsZones(contextRoot, noProgress, dateTime) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      start: dateTime.from + ':00',
      end: dateTime.to + ':59'
    };
    ah.get("".concat(contextRoot, "/zone/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得港區查驗站進出統計

export var getStatsGates = function getStatsGates(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dateTime = arguments.length > 3 ? arguments[3] : undefined;
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      'zone-id': zoneId,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59'
    };
    ah.get("".concat(contextRoot, "/gate/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得港區查驗站進出紀錄

export var getLogsGates = function getLogsGates(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dateTime = arguments.length > 3 ? arguments[3] : undefined;
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'gateName';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'zone-id': zoneId,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59',
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/gate/logs"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場進出統計

export var getStatsTerminals = function getStatsTerminals(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dateTime = arguments.length > 3 ? arguments[3] : undefined;
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      'zone-id': zoneId,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59',
      'stat-type': 'in-out'
    };
    ah.get("".concat(contextRoot, "/terminal/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場交領櫃統計

export var getStatsTerminalsDelivery = function getStatsTerminalsDelivery(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var terminalId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var dateTime = arguments.length > 4 ? arguments[4] : undefined;
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      'zone-id': zoneId,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59',
      'stat-type': 'return-pickup',
      'terminal-id': terminalId
    };
    ah.get("".concat(contextRoot, "/terminal/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場進出紀錄

export var getLogsTerminals = function getLogsTerminals(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dateTime = arguments.length > 3 ? arguments[3] : undefined;
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'terminalName';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'log-type': 'all',
      'zone-id': zoneId,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59',
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/terminal/logs"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場作業貨櫃車輛清單

export var getLogsTerminalsUnfinished = function getLogsTerminalsUnfinished(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var terminalId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'entryTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'log-type': 'unfinished',
      'zone-id': zoneId,
      'terminal-id': terminalId,
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/terminal/logs"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得貨運業者交領櫃次數統計

export var getStatsLogisticsCount = function getStatsLogisticsCount(contextRoot, noProgress, dateTime) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      'stat-type': 'count',
      start: dateTime.from + ':00',
      end: dateTime.to + ':00'
    };
    ah.get("".concat(contextRoot, "/logistic/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得貨運業者交領櫃時間統計

export var getStatsLogisticsDuration = function getStatsLogisticsDuration(contextRoot, noProgress, dateTime) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      'stat-type': 'duration',
      start: dateTime.from + ':00',
      end: dateTime.to + ':00'
    };
    ah.get("".concat(contextRoot, "/logistic/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得前十名平均作業時間最短駕駛

export var getStatsLogisticsTop10 = function getStatsLogisticsTop10(contextRoot, noProgress, dateTime) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      'stat-type': 'top10-drivers',
      start: dateTime.from + ':00',
      end: dateTime.to + ':59'
    };
    ah.get("".concat(contextRoot, "/logistic/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得貨運業者交領櫃作業紀錄

export var getLogsLogisticsAll = function getLogsLogisticsAll(contextRoot, noProgress) {
  var logisticId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var keyword = arguments.length > 3 ? arguments[3] : undefined;
  var dateTime = arguments.length > 4 ? arguments[4] : undefined;
  var sort = arguments.length > 5 ? arguments[5] : undefined;
  var offset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var limit = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'deliverType';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'log-type': 'all',
      'logistic-id': logisticId,
      keyword: keyword,
      start: dateTime.from + ':00',
      end: dateTime.to + ':59',
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/logistic/logs"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得港區查驗站交領櫃待作業清單

export var getLogsLogisticsUnfinished = function getLogsLogisticsUnfinished(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var terminalId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'estBeginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'log-type': 'zone-unfinished',
      'zone-id': zoneId,
      'terminal-id': terminalId,
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/logistic/logs"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場管制站交領櫃待作業清單

export var getLogsLogisticsTerminalUnfinished = function getLogsLogisticsTerminalUnfinished(contextRoot, noProgress) {
  var zoneId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var terminalId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'estBeginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'log-type': 'terminal-unfinished',
      'zone-id': zoneId,
      'terminal-id': terminalId,
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/logistic/logs"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得貨運業者交領櫃預報清單

export var getLogsLogisticsForecast = function getLogsLogisticsForecast(contextRoot, noProgress) {
  var logisticId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var deliverStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'notZoneIn';
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'estBeginTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'log-type': 'forecast',
      'logistic-id': logisticId,
      'deliver-status': deliverStatus,
      sort: sortField + ':' + sortOrder,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/logistic/logs"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得櫃場船舶動態

export var getVessels = function getVessels(contextRoot, noProgress) {
  var terminalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var keyword = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'moveTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      'terminal-id': terminalId,
      sort: sortField + ':' + sortOrder,
      keyword: keyword,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/vessels/live"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};